import { render } from "./GroupHeader.vue?vue&type=template&id=01a53920&scoped=true"
import script from "./GroupHeader.vue?vue&type=script&lang=js"
export * from "./GroupHeader.vue?vue&type=script&lang=js"

import "./GroupHeader.vue?vue&type=style&index=0&id=01a53920&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a53920"]])

export default __exports__